import * as Yup from 'yup'


export const translationValidationSchema = Yup.object({
    labelText: Yup.string().required('Label is required.')
});
